module.exports = __webpack_public_path__ + "img/football-hero-bg.f344d86b.png";